import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../utils/withRouter';
import Loader from '../../utils/Loader'
import { fill_action } from '../../actions/fillList_action';
import { get_additional_services_action, postUpdate_additional_services_action, getServiceVendorPackageDetail_action } from '../../actions/bookingDetails_action/aditionalServices_action';
import { sessionExpireMessage, standardPremiumActionId, toastError, tokenInavlidMessage } from '../../utils/constants';
import { ToastContainer, toast, } from 'react-toastify';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { emailValidator, nameValidator, loginPasswordValidator } from '../../utils/Validator'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Header from '../../common_components/Header';
import Resizer from "react-image-file-resizer";
import companyinfo from './companyinfo';
import { map } from 'jquery';
import BookingDetailsAside from '../../common_components/booking_details/bookingDetailsAside';
import Steps from '../../common_components/booking_details/steps';
import { BASE_URL } from "../../utils/constants";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { el } from 'date-fns/locale';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import $ from 'jquery';

const marks = [];

for (let i = 0; i <= 100000; i++) {
    if (i % 250 === 0) {
        marks.push(
            {
                value: i
            }
        )
    }
}
class AdditionalServices extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            additionalServicesList: [],
            standardPremiumId: '',
            standardPremiumList: [],
            isQuantity: '',
            Ammount: '',
            standerdArray: [],
            premiumArray: [],
            tempStandardArray: [],
            tempStandardArray2: [],
            isOpen: false,
            checkboxFlag: false,
            is_checkbox: '',
            Quantity: '',
            sList: [],
            CenterID: '',
            OrderID: '',
            fileList: [],
            currentImageIndex: 0,
            ClientID: '',
            orderDtlID: '',
            DetailsPremiumArray: [],
            DetailsStandardArray: [],
            show: false,
            CurrencyID: '',
            unlistedAddServices: '',
            includedServices: [],
            externalServices: [],
            vendorPackageList: [],
            dummyVendorPackageList: [],
            indexOfExternalService: '',
            downloadUrl: '',
            showtable: false,
            showPackageDetailsData: '',
            serviceName: '',
            addRequirement: '',
            SliderValue: [0, 100000],
            isCollapsed: false,
            minPrice: 0,
            maxPrice: 100000,
            vendorNameList: [],
            addRequirementIndex: ''
        }

        this.serviceModalShow = this.serviceModalShow.bind(this);
        this.vendorModalClose = this.vendorModalClose.bind(this);
        this.tablePackageDetailsClose = this.tablePackageDetailsClose.bind(this);
        this.tablePackageDetailsShow = this.tablePackageDetailsShow.bind(this);
    }

    componentDidMount() {

        if (JSON.parse(sessionStorage.getItem('UserLoginData')) == null) {
            console.log('log')
            setTimeout(() => {
                this.props.navigate('/login')
            }, 500);
        }

        setTimeout(() => {
            {
                sessionStorage.getItem("roleId") == 4 ?
                    this.props.navigate('/checkList') :
                    <></>
            }
        }, 10);

        const sortUrl = BASE_URL.split('/api')

        this.setState({ downloadUrl: sortUrl[0] })

        this.getFillList(standardPremiumActionId, '')

        setTimeout(() => {
            console.log("additional Services", this.props)
        }, 300);

        this.setState({
            CenterID: this.props.location.state != null && this.props.location.state.CenterID != null ? this.props.location.state.CenterID : '',
            OrderID: this.props.location.state != null && this.props.location.state.OrderID != null ? this.props.location.state.OrderID : '',
            ClientID: this.props.location.state != null && this.props.location.state.ClientID != null ? this.props.location.state.ClientID : '',
        })

        setTimeout(() => {
            this.getAdditionalServicesList()
        }, 200);
    }

    onSliderHandleChange(e, value) {
        const { } = this.state
        this.setState({ minPrice: value[0], maxPrice: value[1] })
        setTimeout(() => {
            this.onSearchPackage()
        }, 200);
    };

    toggleCollapse(isCollapsed, index) {
        const { vendorNameList } = this.state

        // const $content = $('#collapseContent');

        vendorNameList.map((item, i) => {
            if (i === index) {
                if (!isCollapsed) {
                    item.isCollapsed = true
                } else {
                    item.isCollapsed = false
                }
            } else {
                item.isCollapsed = false
            }
        })

        this.setState({ vendorNameList: vendorNameList })
    };

    bookingDetails() {
        const ClientID = this.props.location.state != null && this.props.location.state.ClientID != null ? this.props.location.state.ClientID : ''

        const CenterID = this.props.location.state != null && this.props.location.state.CenterID != null ? this.props.location.state.CenterID : ''

        const isEdit = this.props.location.state != null && this.props.location.state.isEdit != null ? this.props.location.state.isEdit : null

        const OrderID = this.props.location.state != null && this.props.location.state.OrderID != null ? this.props.location.state.OrderID : ''
        this.props.navigate('/BookingDetails', { state: { ClientID: ClientID, OrderID: OrderID, CenterID: CenterID, is_Details: true, isEdit: isEdit } })
    }

    getFillList(value, userID) {
        this.setState({ isLoading: true })
        this.props
            .fill_action(value, (userID == '' || userID == null) ? null : userID)
            .then((data) => {
                if (data.error != 1) {
                    if (value == standardPremiumActionId) {
                        this.setState({ standardPremiumList: data.data, isLoading: false })
                    }
                }
            })
            .catch((e) => {
                console.log(e);
            });

    }

    vendorModalShow = (filePath) => {
        this.setState({
            show: true
        });
        if (filePath != null) {
            const filePathArray = []
            filePathArray.push(filePath.split(','))
            console.log("filePathArray", filePathArray)
            this.setState({ fileList: filePathArray[0] })
        }
    };
    vendorModalClose = () => {
        this.setState({ show: false });
    };

    tablePackageDetailsShow = (data) => {

        this.setState({ showtable: true, showPackageDetailsData: data });
    };

    tablePackageDetailsClose = () => {
        this.setState({ showtable: false });
    };

    serviceModalShow = (id, index, serviceName, requirement) => {
        this.setState({
            isOpen: true,
            serviceName: serviceName,
            addRequirement: requirement,
            addRequirementID: id,
            addRequirementIndex: index,
            // minPrice:null,
            // maxPrice:null
        });
        setTimeout(() => {
            this.getServiceVendorPackageDetail(id, index)
        }, 100);
    };

    onSearchPackage() {
        const { addRequirementID, addRequirementIndex } = this.state
        this.getServiceVendorPackageDetail(addRequirementID, addRequirementIndex)
    }

    serviceModalClose = () => {
        this.setState({
            isOpen: false,
        });

    };

    clearPackageValue() {
        const { vendorPackageList, externalServices, indexOfExternalService } = this.state

        if (vendorPackageList != '' && vendorPackageList.length > 0) {
            vendorPackageList.map((item) => {
                item.IsSelected = 0
            })
            this.setState({ vendorPackageList: vendorPackageList })
        }

        // externalServices.map((item, i) => {
        //     if (i === indexOfExternalService) {
        //         item.Package = null
        //         item.Price = 0
        //         item.PackageID = 0
        //         item.VendorName = ''
        //         item.AdditionalRequirement = ''
        //         item.VendorID = ''
        //     }
        // })
    }

    handleSubmit(e) {
        e.preventDefault()
        const { additionalServicesList, orderDtlID, unlistedAddServices, externalServices } = this.state
        this.setState({ isLoading: true })
        const CenterID = this.props.location.state != null && this.props.location.state.CenterID != null ? this.props.location.state.CenterID : ''
        const OrderID = this.props.location.state != null && this.props.location.state.OrderID != null ? this.props.location.state.OrderID : ''
        const ClientID = this.props.location.state != null && this.props.location.state.ClientID != null ? this.props.location.state.ClientID : ''
        const isEdit = this.props.location.state != null && this.props.location.state.isEdit != null ? this.props.location.state.isEdit : null

        // console.log("Final standerdArray handle submit", externalServices)

        const externalNewArray = []
        if (externalServices != '') {
            externalServices.map((item) => {
                if (item.IsSelected == 1) {
                    externalNewArray.push(item)
                }
            })
        }
        var externalServicesCondition = externalNewArray.every(item => item.Package != null)

        const newArray = []

        additionalServicesList.map((data, i) => {
            // data.Amount == null ? data.Quantity*data.PriceInINR
            if (data.IsSelected == 1) {
                newArray.push(
                    data.CurrencyID != 2 ?
                        {
                            "CenterAdditionalServiceID": data.CenterAdditionalServicesID,
                            "Price": data.PriceInINR,
                            "Quantity": data.Quantity != '' ? data.Quantity : 1,
                            "Amount": data.Amount,
                        }
                        :
                        {
                            "CenterAdditionalServiceID": data.CenterAdditionalServicesID,
                            "Price": data.PriceInUSD,
                            "Quantity": data.Quantity != '' ? data.Quantity : 1,
                            "Amount": data.Amount,
                        }
                )
            }
        })
        console.log("newArray", newArray)


        const externalServicesNewArray = []

        externalServices.map((data, i) => {
            // data.Amount == null ? data.Quantity*data.PriceInINR
            if (data.IsSelected == 1) {
                externalServicesNewArray.push(
                    {
                        "CenterServiceID": data.CenterServicesID,
                        "Service": data.Service,
                        "VendorservicepackageID": data.PackageID,
                        "Price": 0,
                        "Qty": 0,
                        "AdditionalRequirement": data.AdditionalRequirement,
                        "ServiceID": data.ServiceID,
                        "VendorID": data.VendorID,
                    }
                )
            }
        })
        console.log("newArray", externalServicesNewArray)
        if (externalServicesCondition) {
            this.props
                .postUpdate_additional_services_action(OrderID, orderDtlID, CenterID, unlistedAddServices, newArray, externalServicesNewArray, isEdit != '' && isEdit != null ? isEdit : 0)
                .then((data) => {
                    if (data.error != 1) {
                        this.props.navigate('/termsAndConditons', { state: { CenterID: CenterID, OrderID: OrderID, ClientID: ClientID, isEdit: isEdit } })
                        this.setState({ isLoading: false, orderDtlID: data.data[0]['OrderDtlID'] })
                    }
                    else {
                        if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                            //after session expire.....................
                            sessionStorage.clear()
                            this.props.navigate('/normalView')
                            setTimeout(() => {
                                toast.error(data.msg, {
                                    position: "top-center",
                                    theme: "colored",
                                    autoClose: 3000,
                                    hideProgressBar: true,
                                });
                            }, 500);
                        } else {
                            this.setState({ isLoading: false })
                            toast.error(data.data, {
                                position: "top-center",
                                theme: 'colored',
                                autoClose: 3000,
                                hideProgressBar: true,
                            })
                        }
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        } else {
            this.setState({ isLoading: false })
            toastError("Please select package of additional vendor services")
        }
    }

    getAdditionalServicesList() {
        const { orderDtlID } = this.state
        const CenterID = this.props.location.state != null && this.props.location.state.CenterID != null ? this.props.location.state.CenterID : ''
        const OrderID = this.props.location.state != null && this.props.location.state.OrderID != null ? this.props.location.state.OrderID : ''
        // this.setState({ isLoading: true })
        this.props
            .get_additional_services_action(OrderID, CenterID)
            .then((data) => {
                if (data.error != 1) {
                    // console.log("additionalServicesList1234", data.data['additionServices'])
                    if (data.data['externalServices'] != '') {
                        data.data['externalServices'].map((item) => {
                            if (item.Qty == 0) {
                                item.Qty = null
                            }
                        })
                        this.setState({
                            externalServices: data.data['externalServices']
                        })
                    }
                    if (data.data['additionServices'] != '') {
                        this.setState({
                            CurrencyID: data.data['additionServices'][0]['CurrencyID'],
                        })
                    }
                    if (data.data['otherData'] != '') {
                        this.setState({ unlistedAddServices: data.data['otherData'][0]['UnlistedAddServices'] })
                    }
                    if (data.data['includedServices'] != '') {
                        this.setState({ includedServices: data.data['includedServices'] })
                    }

                    for (let i = 0; i < data.data['additionServices'].length; i++) {


                        const filterData = data.data['additionServices'].filter(item => item.Name == data.data['additionServices'][i]['Name'])

                        if (filterData.length == 2) {
                            data.data['additionServices'][i]['Disabled'] = 2
                        } else {
                            data.data['additionServices'][i]['Disabled'] = 1
                        }

                        if (filterData.length == 2) {
                            filterData.map((item) => {
                                if (item.IsSelected == 1) {
                                    item.Is_SelectedServiceId = 1
                                }
                            })
                        }

                        let checked = filterData.every(obj => obj.IsSelected == 0)
                        if (checked) {
                            data.data['additionServices'][i]['Is_SelectedServiceId'] = 1
                        } else {
                            if (data.data['additionServices'][i]['ServiceType'] == 'S') {
                                data.data['additionServices'][i]['Is_SelectedServiceId'] = 1
                            }
                        }

                        data.data['additionServices'].map((item) => {
                            if (item.CurrencyID == 1) {
                                const electricityFlag = item.Name.split(' ').includes('Electricity')
                                if (electricityFlag) {
                                    item.Amount = item.Amount != '' && item.Amount != null ? item.Amount : data.PriceInUSD != 0 ? (data.PriceInUSD) * 30 : ''
                                } else {
                                    item.Amount = item.Amount != '' && item.Amount != null ? item.Amount : data.PriceInINR != 0 ? (data.PriceInINR) : ''
                                }
                            } else {
                                const electricityFlag = item.Name.split(' ').includes('Electricity')
                                if (electricityFlag) {
                                    item.Amount = item.Amount != '' && item.Amount != null ? item.Amount : data.PriceInUSD != 0 ? (data.PriceInUSD) * 30 : ''
                                } else {
                                    item.Amount = item.Amount != '' && item.Amount != null ? item.Amount : data.PriceInINR != 0 ? (data.PriceInINR) : ''
                                }
                            }
                        })
                    }
                    this.setState({ additionalServicesList: data.data['additionServices'] })
                    this.setState({ isLoading: false, })

                }
                else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear()
                        this.props.navigate('/normalView')
                        setTimeout(() => {
                            toast.error(data.msg, {
                                position: "top-center",
                                theme: "colored",
                                autoClose: 3000,
                                hideProgressBar: true,
                            });
                        }, 500);
                    } else {
                        this.setState({ isLoading: false })
                        toast.error(data.data, {
                            position: "top-center",
                            theme: 'colored',
                            autoClose: 3000,
                            hideProgressBar: true,
                        })
                    }
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    getServiceVendorPackageDetail(serviceId, index) {
        const { orderDtlID, externalServices, dummyVendorPackageList, maxPrice, minPrice } = this.state
        const CenterID = this.props.location.state != null && this.props.location.state.CenterID != null ? this.props.location.state.CenterID : ''
        const OrderID = this.props.location.state != null && this.props.location.state.OrderID != null ? this.props.location.state.OrderID : ''
        this.setState({ isLoading: true })
        this.props
            .getServiceVendorPackageDetail_action(CenterID, serviceId, OrderID, minPrice, maxPrice)
            .then((data) => {
                if (data.error != 1) {

                    if (data.data != '') {
                        var array = []
                        data.data.map((item) => {
                            item.index = index
                        })
                        array = data.data
                        array.map((item) => {
                            dummyVendorPackageList.push(item)
                        })

                        setTimeout(() => {
                            const arrayOfObjects = this.removeDuplicatesFromArray(dummyVendorPackageList)
                            this.setState({ dummyVendorPackageList: arrayOfObjects })

                            const newObject = this.calculateFrequencyAndConvert(data.data)
                            const array = []
                            data.data.map((item, i) => {
                                if (!array.some(obj => obj.VendorID == item.VendorID)) {
                                    array.push({
                                        name: item.CompanyName,
                                        VendorID: item.VendorID,
                                        isCollapsed: false
                                    });
                                }
                            })

                            array.map((item, i) => {
                                newObject.map((obj, i) => {
                                    if (item.VendorID == obj.VendorID) {
                                        item.frequency = newObject[i]['frequency']
                                    }
                                })
                            })
                            console.log("newObject", newObject)
                            console.log("data.data", data.data)
                            console.log("array", array)

                            if (data.price != '') {
                                const priceArray = []
                                priceArray.push(data.price[0]['MinPrice'], data.price[0]['MaxPrice'])
                                console.log("priceArray--------", priceArray)

                                this.setState({ SliderValue: priceArray, minPrice: data.price[0]['MinPrice'], maxPrice: data.price[0]['MaxPrice'] })
                            }

                            this.setState({ vendorPackageList: data.data, vendorNameList: array, })
                            console.log("vendorPackageList---", data.data)

                        }, 100);

                        this.setState({ indexOfExternalService: index, isLoading: false })
                    } else {
                        this.setState({ isLoading: false, vendorPackageList: [], vendorNameList: [], })
                    }
                }
                else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear()
                        this.props.navigate('/normalView')
                        setTimeout(() => {
                            toast.error(data.msg, {
                                position: "top-center",
                                theme: "colored",
                                autoClose: 3000,
                                hideProgressBar: true,
                            });
                        }, 500);
                    } else {
                        this.setState({ isLoading: false })
                        toast.error(data.data, {
                            position: "top-center",
                            theme: 'colored',
                            autoClose: 3000,
                            hideProgressBar: true,
                        })
                    }
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    removeDuplicatesFromArray(arrayOfObjects) {
        // Create a map to store unique combinations of id and index
        let uniqueMap = {};

        // Filter out duplicates based on id and index
        let uniqueArray = arrayOfObjects.filter(obj => {
            // Create a unique key based on id and index
            let key = obj.VendorID + '-' + obj.index;

            // If the key is not in the map, add it and return true (include in the result)
            if (!uniqueMap[key]) {
                uniqueMap[key] = true;
                return true;
            }

            // If the key is already in the map, return false (exclude from the result)
            return false;
        });

        return uniqueArray;
    }

    checkVendorPackageSelectedOrNot() {
        const { vendorPackageList } = this.state

        const condition = vendorPackageList.some((item) => item.IsSelected == 1)

        return condition
    }

    isQuantity(e, index, name, maxQantity) {
        const { additionalServicesList } = this.state;
        const cList = [...additionalServicesList];

        const event = e.target.value.replace(/\D/, '')

        const electricityFlag = name.split(' ').includes('Electricity')
        console.log("event electricityFlag", electricityFlag)

        cList.forEach((data, i) => {

            if (data.Name == name) {
                if (data.CurrencyID == 1) {
                    if (event > 0) {
                        if (maxQantity >= event) {
                            if (electricityFlag) {
                                data.Quantity = event
                                data.Amount = (data.PriceInINR) * 30 * event
                            } else {
                                data.Quantity = event
                                data.Amount = (data.PriceInINR) * event
                            }
                        } else {
                            toastError(`Max Qantity is ${maxQantity}`)
                            data.Amount = (data.PriceInINR)
                            data.Quantity = ''
                        }
                    } else {
                        if (electricityFlag) {
                            data.Quantity = ''
                            data.Amount = (data.PriceInINR) * 30
                        } else {
                            data.Quantity = ''
                            data.Amount = (data.PriceInINR)
                        }
                    }
                } else {
                    if (event > 0) {
                        if (maxQantity >= event) {
                            if (electricityFlag) {
                                data.Quantity = event
                                data.Amount = (data.PriceInUSD) * 30 * event
                            } else {
                                data.Quantity = event
                                data.Amount = (data.PriceInUSD) * event
                            }
                        } else {
                            toastError(`Max Qantity is ${maxQantity}`)
                            data.Amount = (data.PriceInUSD)
                            data.Quantity = ''
                        }
                    } else {
                        if (electricityFlag) {
                            data.Quantity = ''
                            data.Amount = (data.PriceInUSD) * 30
                        } else {
                            data.Quantity = ''
                            data.Amount = (data.PriceInUSD)
                        }
                    }
                }
            }
        });

        this.setState({
            additionalServicesList: cList,
        });
        // console.log("XXXXXXXX checkboxFlag XXXXXXX", cList)

    }

    isAmountQuantity(e, index, name, maxQantity) {
        const { additionalServicesList } = this.state;
        const cList = [...additionalServicesList];

        const event = e.target.value.replace(/\D/, '')

        const electricityFlag = name.split(' ').includes('Electricity')
        console.log("event electricityFlag", electricityFlag)

        cList.forEach((data, i) => {
            if (data.Name == name) {
                if (event != '') {
                    data.Amount = event
                } else {
                    data.Amount = ''
                }
            }
        });

        this.setState({
            additionalServicesList: cList,
        });
        // console.log("XXXXXXXX checkboxFlag XXXXXXX", cList)

    }

    externalServicesAdditionalRequirement(e, index) {
        const { externalServices } = this.state;
        const cList = [...externalServices];

        const event = e.target.value

        cList.forEach((data, i) => {
            if (i === index) {
                data.AdditionalRequirement = event
            }
        });

        this.setState({
            externalServices: cList,
        });
        // console.log("XXXXXXXX checkboxFlag XXXXXXX", cList)
    }

    externalServicesQuantity(e, index) {
        const { externalServices } = this.state;
        const cList = [...externalServices];

        const event = e.target.value.replace(/\D/, '')

        cList.forEach((data, i) => {
            if (i === index) {
                if (event != '') {
                    data.Qty = event
                } else {
                    data.Qty = ''
                }
            }
        });

        this.setState({
            externalServices: cList,
        });
        // console.log("XXXXXXXX checkboxFlag XXXXXXX", cList)
    }

    includedServicesCheckbox(index, IsSelected, e) {

        const { includedServices } = this.state;
        const cList = [...includedServices];
        const event = e.target.checked

        cList.forEach((data, i) => {
            if (i === index) {
                if (IsSelected == 0) {
                    data.IsSelected = 1
                } else {
                    data.IsSelected = 0
                }
            }
        });

        this.setState({
            includedServices: cList,
        });
        // console.log("XXXXXXXX checkboxFlag XXXXXXX", cList)
    }

    externalServicesCheckbox(index, IsSelected, e) {

        const { externalServices } = this.state;
        const cList = [...externalServices];
        const event = e.target.checked

        cList.forEach((data, i) => {
            if (i === index) {
                if (IsSelected == 0) {
                    data.IsSelected = 1
                } else {
                    data.IsSelected = 0
                    data.Qty = ''
                    data.Package = null
                    data.Price = 0
                    data.PackageID = 0
                    data.VendorName = ''
                    data.AdditionalRequirement = ''
                    data.VendorID = ''
                    this.clearPackageValue()
                }
            }
        });

        this.setState({
            externalServices: cList,
        });
    }

    checkbox(index, IsSelected, e) {

        const { additionalServicesList } = this.state;
        const cList = [...additionalServicesList];
        const event = e.target.checked
        cList.forEach((data, i) => {
            if (i === index) {
                const electricityFlag = data.Name.split(' ').includes('Electricity')
                if (data.CurrencyID == 1) {
                    if (IsSelected == 0) {
                        if (electricityFlag) {
                            data.IsSelected = 1
                            if (data.Name != 'Event Services') {
                                data.Quantity = 1
                            }
                            data.Amount = data.PriceInINR != 0 ? (data.PriceInINR) * 30 : ''
                        } else {
                            data.IsSelected = 1
                            if (data.Name != 'Event Services') {
                                data.Quantity = 1
                            }
                            data.Amount = data.PriceInINR != 0 ? (data.PriceInINR) : ''
                        }
                    } else {
                        if (electricityFlag) {
                            data.IsSelected = 0
                            data.Quantity = ''
                        } else {
                            data.IsSelected = 0
                            data.Quantity = ''
                        }
                    }
                } else {
                    if (IsSelected == 0) {
                        if (electricityFlag) {
                            data.IsSelected = 1
                            data.Quantity = 1
                            data.Amount = data.PriceInUSD != 0 ? (data.PriceInUSD) * 30 : ''
                        } else {
                            data.IsSelected = 1
                            data.Quantity = 1
                            data.Amount = data.PriceInUSD != 0 ? (data.PriceInUSD) : ''
                        }
                    } else {
                        if (electricityFlag) {
                            data.IsSelected = 0
                            data.Quantity = ''
                        } else {
                            data.IsSelected = 0
                            data.Quantity = ''
                        }
                    }
                }
            }
        });

        this.setState({
            additionalServicesList: cList,
        });
        console.log("XXXXXXXX checkboxFlag XXXXXXX", cList)

    }

    onServicetypechange(e, index, name, Quantity) {
        const { additionalServicesList } = this.state;
        const cList = [...additionalServicesList];
        const event = e.target.value
        console.log("event", event[0].toString())
        var List

        cList.forEach((data, i) => {
            // if (i === index) {
            if (data.Name == name) {
                console.log(data.ServiceType)

                if (data.ServiceType == event[0].toString()) {
                    // console.log('sdgfsd');

                    data.Is_SelectedServiceId = 1
                    data.IsSelected = 1
                    // console.log("data.Quantity", Quantity)
                    data.Quantity = Quantity
                    this.setState({
                        additionalServicesList: cList,
                    });
                } else {
                    // console.log('sdgfqweqsd');
                    data.Is_SelectedServiceId = 0
                    data.IsSelected = 0
                    this.setState({
                        additionalServicesList: cList,
                    });
                }

                console.log("data", data)
            }
            // }
        });

        this.setState({
            additionalServicesList: cList,
        });
        console.log("XXXXXXXX onServicetypechange XXXXXXX", cList)
    }

    handleKeyDown(e) {
        if (e.code === 'Enter') {
            this.handleSubmit(e)
        }
    }

    vendorPackageCheckbox(index, IsSelected, e) {
        const { vendorPackageList, indexOfExternalService, externalServices, dummyVendorPackageList } = this.state;
        const cList = [...vendorPackageList];
        const event = e.target.checked
        console.log("event----", event)

        cList.forEach((data, i) => {
            if (i === index) {
                if (event) {
                    data.IsSelected = 1
                    dummyVendorPackageList.map((obj) => {
                        if (obj.VendorServicesPackageID == data.VendorServicesPackageID && obj.index == data.index) {
                            obj.IsSelected = 1
                        } else {
                            obj.IsSelected = 0
                        }
                    })
                    externalServices.map((item, i) => {
                        if (i === indexOfExternalService) {
                            item.Package = data.Package
                            item.Price = data.Rate
                            item.PackageID = data.VendorServicesPackageID
                            item.VendorName = data.VendorName
                            item.CompanyName = data.CompanyName
                            item.VendorID = data.VendorID
                        }
                    })
                    this.setState({ externalServices: externalServices, dummyVendorPackageList: dummyVendorPackageList })
                } else {
                    data.IsSelected = 0
                    data.Description = ''
                    dummyVendorPackageList.map((obj) => {
                        if (obj.VendorServicesPackageID == data.VendorServicesPackageID && obj.index == data.index) {
                            obj.IsSelected = 0
                        }
                    })
                    externalServices.map((item, i) => {
                        if (i === indexOfExternalService) {
                            item.Package = null
                            item.Price = 0
                            item.PackageID = 0
                            item.VendorName = ''
                            item.CompanyName = ''
                            item.VendorID = ''
                        }
                    })
                    this.setState({ externalServices: externalServices, dummyVendorPackageList: dummyVendorPackageList })
                }
            } else {
                data.IsSelected = 0
            }
        });
        setTimeout(() => {
            console.log("vendorPackageList---", cList)
        }, 200);

        this.setState({
            vendorPackageList: cList,
        });
    }

    additionRequirement(item) {
        const { externalServices, addRequirementID } = this.state
        externalServices.map((data) => {
            if (addRequirementID == data.ServiceID) {
                if (data != '') {
                    data.AdditionalRequirement = item
                } else {
                    data.AdditionalRequirement = ''
                }
            }
        })

        this.setState({ externalServices: externalServices })
    }

    onPrice(e, type) {
        const { minPrice, maxPrice } = this.state
        const event = e.target.value.replace(/\D/, "")
        if (type == 'min') {
            if (event <= maxPrice) {
                this.setState({ minPrice: event, SliderValue: [event, maxPrice] })
            }
        } else {
            if (event >= minPrice) {
                this.setState({ maxPrice: event, SliderValue: [minPrice, event] })
            }
        }
    }

    calculateFrequencyAndConvert(data) {
        const frequencyMap = {};
        data.forEach(obj => {
            const value = obj.VendorID;
            frequencyMap[value] = (frequencyMap[value] || 0) + 1;
        });
        const result = [];
        for (const key in frequencyMap) {
            result.push({ frequency: frequencyMap[key], VendorID: parseInt(key) });
        }

        return result;
    }

    render() {
        const { isLoading, standardPremiumId, standardPremiumList, standerdArray, isOpen, fileList, additionalServicesList, CenterID, show, CurrencyID, unlistedAddServices, includedServices, externalServices, vendorPackageList, downloadUrl, showPackageDetailsData, showtable, serviceName, addRequirement, SliderValue, isCollapsed, minPrice, maxPrice, vendorNameList } = this.state

        // console.log("premiumArray", premiumArray)

        return (
            <>
                {isLoading ? <Loader></Loader> : null}

                <main id="main">
                    <Header data={JSON.parse(sessionStorage.getItem('Is_modify')) != true && this.state.OrderID != null && this.state.OrderID != '' ? [2, true] : [2]} />

                    <section style={{ marginTop: "115px" }}>
                        <div class="container-fluid">
                            <div class="row">
                                {(CenterID != '' && CenterID != null) && <BookingDetailsAside data={CenterID} />}
                                <div class="col-md-9">
                                    <div class="md-stepper-horizontal orange">
                                        <Steps data={3} />
                                    </div>

                                    <div class="venue-booking-block" id="venue-availability-form" style={{ marginBottom: "15px" }}>
                                        <form class="form-horizontal sky-form" role="form" autocomplete="off">

                                            <div class="company_info">

                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <h6 class="additional_services">Inclusive Services</h6>
                                                        <ul class="Included_Services">
                                                            {
                                                                includedServices.length > 0 && includedServices != null ? (
                                                                    includedServices.map((data, i) => (
                                                                        <li>{data.InclusiveServices}</li>
                                                                    ))
                                                                ) : <></>
                                                            }
                                                        </ul>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="form-group">
                                                            <h6 class="additional_services">Additional Paid Services</h6>

                                                            <div className='custom_table'>
                                                                <div className='hack1'>
                                                                    <div className='hack2'>
                                                                        <table class="table table-bordered table-striped table-sm" style={{ zIndex: '000', position: 'relative' }} id="tbl">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th style={{ width: '2%' }}></th>
                                                                                    <th className='Service_col_width' >Services</th>
                                                                                    <th class="text-center Service_type_width" style={{ width: '16%' }}>Type</th>
                                                                                    {
                                                                                        CurrencyID != 2 ? <th class="text-center Service_prize_width" style={{ width: '16%' }}>Price (INR) </th> : <th class="text-center" style={{ width: '16%' }}>Price (USD) </th>
                                                                                    }
                                                                                    <th class="text-center" style={{ width: "10%" }}>Quantity</th>
                                                                                    {
                                                                                        CurrencyID != 2 ? <th class="text-right Service_prize_width" style={{ width: '16%' }}>Amount (INR) </th> : <th class="text-center" style={{ width: '16%' }}>Amount (USD) </th>
                                                                                    }
                                                                                </tr>
                                                                            </thead>

                                                                            <tbody>
                                                                                {/* '₹' : '$' */}
                                                                                {
                                                                                    additionalServicesList.length > 0 && additionalServicesList != null ? (
                                                                                        additionalServicesList.map((std, i) => (
                                                                                            <>
                                                                                                {
                                                                                                    std.Is_SelectedServiceId == 1 ?
                                                                                                        // <>
                                                                                                        //     {
                                                                                                        //         std.Name != "Electricity" ?
                                                                                                        <tr key={i}>
                                                                                                            <td>
                                                                                                                <div class="bg">
                                                                                                                    <div class="chiller_cb">
                                                                                                                        <input
                                                                                                                            type="checkbox"
                                                                                                                            onClick={(e) => this.checkbox(i, std.IsSelected, e)}
                                                                                                                            id={`checkbox${i}`}
                                                                                                                            checked={std.IsSelected}

                                                                                                                        />
                                                                                                                        <label
                                                                                                                            for={`checkbox${i}`}
                                                                                                                            style={{ color: "#979797;" }}>&nbsp;</label>
                                                                                                                        <span></span>
                                                                                                                    </div>

                                                                                                                </div>
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                <div>{std.Name} &nbsp;
                                                                                                                    {
                                                                                                                        std.FilePath != '' ?
                                                                                                                            <a href="javascript:void(0);" data-toggle="modal"
                                                                                                                                onClick={(e) => this.modalShow(std.FilePath, i)}
                                                                                                                                data-target="#Additional_Services_img_Pop"><i class="fa fa-picture-o" style={{ color: "#006fff" }}></i></a> : <></>
                                                                                                                    }&nbsp;
                                                                                                                    {
                                                                                                                        std.ServiceDetails != null && std.ServiceDetails != '' ?
                                                                                                                            <span class="tooltip-col"><i class="fa fa-info-circle" aria-hidden="true"></i>
                                                                                                                                <span class="tooltiptext">{std.ServiceDetails}</span>
                                                                                                                            </span> : <></>
                                                                                                                    }
                                                                                                                </div>
                                                                                                            </td>
                                                                                                            {/* {std.Name != "Electricity" ? */}
                                                                                                            <td>

                                                                                                                <select class="form-control"

                                                                                                                    value={std.ServiceType == 'S' ? 'Standard' : "Premium"}
                                                                                                                    disabled={!std.IsSelected || std.Disabled != 2}
                                                                                                                    style={{ cursor: "pointer" }}
                                                                                                                    // onChange={(e) => this.stdPrm(e, i)}
                                                                                                                    onChange={(e) => this.onServicetypechange(e, i, std.Name, std.Quantity)}
                                                                                                                // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                                >

                                                                                                                    {standardPremiumList.length > 0 && standardPremiumList.map(item => (
                                                                                                                        <option
                                                                                                                            key={item.ID}
                                                                                                                            value={item.Type}>
                                                                                                                            {item.Type}
                                                                                                                        </option>
                                                                                                                    ))}

                                                                                                                </select>
                                                                                                            </td>
                                                                                                            {/* :
                                                                                                                <td colSpan={4} style={{ color: '#212529', marginBottom: '0px' }}>
                                                                                                                    Electricity rate –RS. 16/- per kwh
                                                                                                                </td>
                                                                                                            } */}
                                                                                                            {/* {std.Name != "Electricity" ?
                                                                                                                <> */}
                                                                                                            {std.Name != 'Event Services' ?
                                                                                                                <td class="text-center">
                                                                                                                    {
                                                                                                                        std.CurrencyID != 2 ? 
                                                                                                                            std.PriceInINR != null ? '₹ ' + std.PriceInINR.toLocaleString("en-IN") : <></> :

                                                                                                                            std.PriceInUSD != null ? '$ ' + std.PriceInUSD.toLocaleString("en-IN") : <></>
                                                                                                                    }</td> :
                                                                                                                <td class="text-center">-</td>
                                                                                                            }
                                                                                                            {std.Name != 'Event Services' ?
                                                                                                                <td class="text-center">
                                                                                                                    <input type="text"
                                                                                                                        className='form-control text-center'
                                                                                                                        value={std.Quantity}
                                                                                                                        onChange={(e) => this.isQuantity(e, i, std.Name, std.MaxQuantity)}
                                                                                                                        disabled={!std.IsSelected}
                                                                                                                        style={{ outline: 'none' }}
                                                                                                                    // maxLength={3}
                                                                                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                                    />
                                                                                                                </td> :
                                                                                                                <td class="text-center">-</td>
                                                                                                            }
                                                                                                            {std.Name != 'Event Services' ?
                                                                                                                <>
                                                                                                                    {std.CurrencyID == 1 ?
                                                                                                                        <td class="text-right">
                                                                                                                            {std.IsSelected == 1 ? '₹ ' + std.Amount.toLocaleString() : '-'}
                                                                                                                        </td> :
                                                                                                                        <td class="text-right">
                                                                                                                            {std.IsSelected == 1 ? '$ ' + std.Amount.toLocaleString() : '-'}
                                                                                                                        </td>
                                                                                                                    }
                                                                                                                </> :
                                                                                                                <td class="text-right">
                                                                                                                    <input type="text"
                                                                                                                        className='form-control text-right'
                                                                                                                        value={std.Amount}
                                                                                                                        onChange={(e) => this.isAmountQuantity(e, i, std.Name, std.MaxQuantity)}
                                                                                                                        disabled={!std.IsSelected||sessionStorage.getItem('roleId')==3}
                                                                                                                        style={{ outline: 'none' }}
                                                                                                                    // maxLength={3}
                                                                                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                                                    />
                                                                                                                </td>
                                                                                                            }
                                                                                                        </tr>
                                                                                                        //             : "sagar"
                                                                                                        //     }
                                                                                                        // </>
                                                                                                        : <></>
                                                                                                }
                                                                                            </>
                                                                                        ))
                                                                                    ) : (<tr><td colSpan={6} className='text-center' style={{ color: '#F96302' }}>Additional services will be available soon.</td></tr>)
                                                                                }

                                                                            </tbody>

                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="form-group">
                                                            <h6 class="additional_services">Additional Vendor Services</h6>
                                                            <table class="table table-bordered table-striped table-sm" id="tbl">
                                                                <thead>
                                                                    <tr>
                                                                        <th style={{ width: "5%" }}></th>
                                                                        <th style={{ width: "25%" }}>SERVICE</th>
                                                                        <th style={{ width: "18%" }}>SELECT PACKAGE</th>
                                                                        <th style={{ width: "18%" }}>VENDOR NAME</th>
                                                                        {/* <th>PRICE (INR)</th>
                                                                            <th style={{ width: "10%" }}>QUANTITY</th> */}
                                                                        {/* <th style={{ width: "35%" }}>ADDITIONAL REQUIREMENT</th> */}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        externalServices.length > 0 && externalServices != null ? (
                                                                            externalServices.map((data, i) => (
                                                                                <tr>
                                                                                    <td>
                                                                                        <div class="bg">
                                                                                            <div class="chiller_cb">
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    onClick={(e) => this.externalServicesCheckbox(i, data.IsSelected, e)}
                                                                                                    id={`externalServicesCheckbox${i}`}
                                                                                                    checked={data.IsSelected}
                                                                                                />
                                                                                                <label
                                                                                                    for={`externalServicesCheckbox${i}`}
                                                                                                    style={{ color: "#979797;" }}>&nbsp;</label>
                                                                                                <span></span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td>
                                                                                        {data.Service}
                                                                                    </td>
                                                                                    {
                                                                                        data.IsSelected == 1 ?
                                                                                            <>
                                                                                                {
                                                                                                    data.Package == null ?
                                                                                                        <td style={{ "cursor": 'pointer', background: "#fcf5f3" }}
                                                                                                            onClick={() => this.serviceModalShow(data.ServiceID, i, data.Service, data.AdditionalRequirement)}>
                                                                                                            <a title="Select Package"

                                                                                                            > Select Package<span class="mendatory_class">*</span></a>
                                                                                                        </td>
                                                                                                        :
                                                                                                        <td>
                                                                                                            <a title="Select Package" style={{ "cursor": 'pointer' }}
                                                                                                                onClick={() => this.serviceModalShow(data.ServiceID, i, data.Service, data.AdditionalRequirement)}
                                                                                                            ><i class="fa fa-edit" style={{ fontSize: '14px' }}></i> {data.Package}</a>
                                                                                                        </td>
                                                                                                }
                                                                                            </>
                                                                                            : <td>{'-'}</td>
                                                                                    }

                                                                                    <td>
                                                                                        {
                                                                                            data.Package != null && data.IsSelected != 0 ?
                                                                                                <>
                                                                                                    {data.CompanyName}
                                                                                                </>
                                                                                                : '-'
                                                                                        }

                                                                                    </td>
                                                                                    {/* <td>{
                                                                                            data.IsSelected == 1 ?
                                                                                                <>
                                                                                                    {data.Price}
                                                                                                </>
                                                                                                : '-'
                                                                                        }
                                                                                        </td> */}
                                                                                    {/* <td>
                                                                                            <input
                                                                                                value={data.Qty}
                                                                                                disabled={data.IsSelected == 0 || data.Package == null}
                                                                                                onChange={(e) => this.externalServicesQuantity(e, i)}
                                                                                                maxLength={4}
                                                                                                className='form-control' type='text' />
                                                                                        </td> */}
                                                                                    {/* <td>
                                                                                            <input className='form-control'
                                                                                                maxLength={200}
                                                                                                disabled={data.IsSelected == 0}
                                                                                                value={data.AdditionalRequirement}
                                                                                                onChange={(e) => this.externalServicesAdditionalRequirement(e, i)}
                                                                                                type='text' />
                                                                                        </td> */}
                                                                                </tr>
                                                                            ))
                                                                        ) : (<tr><td colSpan={12} className='text-center'>Record not found</td></tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div className='col-md-12'>
                                                        {/* <h6 class="additional_services">Any other</h6> */}
                                                        {/* additional_services
                                                            unListed-additional-services */}
                                                        <h6 className='additional_services' >
                                                            Any additional services required not listed above will be check by operation team and can be made available on the basis of type and avalability.</h6>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="form-group">
                                                            <textarea maxLength={1000}
                                                                value={unlistedAddServices}
                                                                onChange={(e) => this.setState({ unlistedAddServices: e.target.value })}
                                                                style={{ height: '180px', resize: 'none' }}
                                                                class="form-control" rows="3" placeholder="Type here..."></textarea>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div style={{ color: "#dc3545", marginBottom: '10px', }} className='d-flex'>
                                                    <strong>
                                                        <p style={{ margin: '0px' }} >Note:</p>
                                                        <p className='d-flex' style={{ flexDirection: 'column' }} >
                                                            <span >Inhouse Paid Service and Third-Party Service can be applied till 7 days prior to the event date. Post the mentioned timeline requested services will be charged at double the rate & subject to availability.</span>
                                                        </p>
                                                    </strong>
                                                </div>

                                                <div class="row">
                                                    <div class="col-md-12 my_buttons">
                                                        <a class="btn btn-secondary custom_btn previous_to_event_info_btn" onClick={(e) => this.bookingDetails(e)}>Step 2 <span className='hide_on_mobile_css'>: Booking Details</span></a>
                                                        <button onClick={(e) => this.handleSubmit(e)} class="btn btn-primary custom_btn Terms_and_Conditions_btn">Step 4 <span className='hide_on_mobile_css'>: Terms & Conditions</span></button>
                                                    </div>
                                                </div>
                                            </div>

                                        </form>
                                    </div>



                                </div>
                            </div>
                        </div>
                    </section >

                </main >
                <ToastContainer />

                <Modal show={isOpen} size='lg'
                // onHide={this.serviceModalClose} 
                >
                    <Modal.Header className='pb-0'>

                        <Modal.Title style={{ width: '100%' }}>

                            <div className=' d-flex mr-5 mb-4' style={{ justifyContent: 'space-between' }}>
                                <div className='pack-name'>
                                    <span> Available package for <span style={{ fontSize: '20px', color: '#1976D2' }}>{serviceName}</span></span>
                                </div>
                                <div className='d-flex'>
                                    <div className='mr-4 m-1'>Pricing : </div>
                                    <div>
                                        <Box sx={{ width: 200 }}>
                                            <Slider
                                                value={SliderValue}
                                                onChangeCommitted={(e, value) => this.onSliderHandleChange(e, value)}
                                                onChange={(e) => this.setState({ SliderValue: e.target.value })}
                                                valueLabelDisplay="on"
                                                max={100000}
                                                marks={marks}
                                                step={null}
                                            />
                                        </Box>
                                    </div>
                                    {/* <div>
                                        <button
                                            onClick={() => this.onSearchPackage()}
                                            class="btn btn-info ml-3 p-1"
                                        >
                                            Search
                                        </button>
                                    </div> */}
                                </div>
                            </div>
                        </Modal.Title>
                        <span
                            onClick={this.serviceModalClose}
                            style={{ cursor: "pointer", fontWeight: "800" }}
                        >
                            X
                        </span>
                    </Modal.Header>

                    <Modal.Body className='pb-0 p-3 cat-pop' style={{ marginBottom: '0px', overflowY: 'auto', }}>
                        {/* <div>
                            <span className='mr-2'>Minimum Price : </span>
                            <input
                                placeholder='0'
                                type="text"
                                className='form-control'
                                value={minPrice != 0 ? minPrice : ''}
                                onChange={(e) => this.onPrice(e, 'min')}
                                maxLength={6}
                                disabled
                            />
                        </div>
                        <div>
                            <span className='mr-2'>Maximum Price : </span>
                            <input
                                placeholder='0'
                                type="text"
                                className='form-control'
                                value={maxPrice != 0 ? maxPrice : ''}
                                onChange={(e) => this.onPrice(e, 'max')}
                                maxLength={6}
                                disabled
                            />
                        </div> */}
                        <div className=''>
                            <div className="search_accordion search_card  m-0" style={{ background: 'none' }}>
                                <div className="panel-group" id="accordion">
                                    {vendorNameList.length > 0 ?
                                        vendorNameList.map((item, i) => (
                                            <div className="panel panel-default mb-2" style={{ background: '#f3f3f3' }}>
                                                <div
                                                    className="panel-heading accordion-toggle collapsed p-2"
                                                    data-toggle="collapse"
                                                    data-parent="#accordion"
                                                    data-target="#collapseOne"
                                                    onClick={() => this.toggleCollapse(item.isCollapsed, i)}
                                                >

                                                    <h4 className="panel-title d-flex" style={{ justifyContent: 'space-between' }}>
                                                        <span style={{ marginTop: '5px' }}>{item.name}</span>
                                                        <span className='packages'>{item.frequency} options</span>
                                                    </h4>
                                                </div>
                                                <div id="collapseContent" style={{ display: !item.isCollapsed ? 'none' : 'block' }}>

                                                    <div className="thankYou_page" style={{ marginTop: '0px' }}>
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                {
                                                                    vendorPackageList.length > 0 && vendorPackageList != '' ?
                                                                        vendorPackageList.map((data, i) => (
                                                                            <>
                                                                                {data.VendorID == item.VendorID ?
                                                                                    <div class="card" style={{ marginBottom: '10px' }}>
                                                                                        <div class="card-body p-2">
                                                                                            <div class="company_info d-flex">
                                                                                                <div class="bg">
                                                                                                    <div class="chiller_cb">
                                                                                                        <input
                                                                                                            id={`vendorPackageCheckbox${i}`}
                                                                                                            type="checkbox"
                                                                                                            // onClick={(e) => console.log("sagar------", e.target.checked)}
                                                                                                            onClick={(e) => this.vendorPackageCheckbox(i, data.IsSelected, e)}
                                                                                                            checked={data.IsSelected}
                                                                                                        />
                                                                                                        < label for={`vendorPackageCheckbox${i}`} style={{ color: "#000", fontSize: "13px" }}> &emsp; </label>
                                                                                                        <span></span>
                                                                                                    </div>
                                                                                                </div>

                                                                                                <div style={{ width: '100%' }}>
                                                                                                    <p className='m-0'>{data.CompanyName} / <spa className="pac-nam">{data.Package}</spa></p>
                                                                                                    <div class="card" style={{ width: '100%', margin: '5px 0 5px 0' }}>
                                                                                                        <div class="card-body p-2">
                                                                                                            <pre style={{ margin: 0, padding: 0 }}
                                                                                                                dangerouslySetInnerHTML={{
                                                                                                                    __html:
                                                                                                                        data.PackageDetails,
                                                                                                                }}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    {
                                                                                                        data.FilePath != null ?
                                                                                                            <p className='m-0'> Images:{' '}
                                                                                                                <a title="Show Images" style={{ "cursor": 'pointer', fontSize: '18px' }}
                                                                                                                    onClick={() => this.vendorModalShow(data.FilePath)}
                                                                                                                ><i class="fa fa-image"></i></a>
                                                                                                            </p>
                                                                                                            : <></>
                                                                                                    }
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    : <></>}
                                                                            </>
                                                                        ))
                                                                        : (<tr><td colSpan={12} className='text-center'>Record not found</td></tr>)
                                                                }

                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        ))
                                        : <>
                                          <div class="company_info d-flex" style={{textAlign:"center"}}>Packages Not Available</div></>
                                    }
                                    {
                                        vendorPackageList.length > 0 && vendorPackageList != '' ?
                                            <>
                                                <p className='m-0 pt-2 bot-add'>Additional Requirement:</p>
                                                <CKEditor
                                                    editor={ClassicEditor}
                                                    data={
                                                        addRequirement
                                                    }
                                                    onChange={(event, editor) => {
                                                        const data = editor.getData();
                                                        this.additionRequirement(data)
                                                    }}
                                                />
                                            </>
                                            : <></>
                                    }
                                </div>
                            </div>

                        </div>


                    </Modal.Body>
                    <div className='model-footer model-footer p-2 pt-0 pr-3'>
                        <div style={{ textAlign: 'right' }}>
                            {
                                vendorPackageList.length > 0 && vendorPackageList != '' ?
                                    <button
                                        onClick={() => this.setState({ isOpen: false })}
                                        class="btn btn-outline-success mr-2"
                                    >
                                        Submit
                                    </button>
                                    : <></>
                            }
                            <button
                                onClick={() => this.serviceModalClose()}
                                class="btn btn-outline-secondary mr-2"
                            >
                                Cancel

                            </button>
                        </div>
                    </div>
                </Modal >


                <Modal show={show} onHide={this.vendorModalClose} size='md'>
                    <Modal.Header>
                        <Modal.Title>Vendor Images</Modal.Title>
                        <span
                            onClick={this.vendorModalClose}
                            style={{ cursor: "pointer", fontWeight: "800" }}
                        >
                            X
                        </span>
                    </Modal.Header>

                    <Modal.Body style={{ marginBottom: '0px' }}>

                        {/* {
                            fileList.length && */}

                        <OwlCarousel style={{ zIndex: '1' }} items={1}
                            loop
                            nav
                            margin={20}
                        >
                            {
                                fileList != '' ?
                                    fileList.map((imageUrl, i) => (
                                        <>
                                            {console.log("imageUrl--", imageUrl.trim())}
                                            <img alt="" title="" src={downloadUrl + imageUrl.trim()} className="booking_page_img" />
                                        </>
                                    )) : <></>
                            }

                        </OwlCarousel>
                        {/* } */}

                    </Modal.Body>

                </Modal>

                <Modal show={showtable} onHide={this.tablePackageDetailsClose} size='md'>
                    <Modal.Header>
                        <Modal.Title>Vendor Package Details</Modal.Title>
                        <span
                            onClick={this.tablePackageDetailsClose}
                            style={{ cursor: "pointer", fontWeight: "800" }}
                        >
                            X
                        </span>
                    </Modal.Header>

                    <Modal.Body style={{ marginBottom: '0px' }}>

                        {/* {
                            fileList.length && */}
                        <div>
                            <pre
                                dangerouslySetInnerHTML={{
                                    __html:
                                        showPackageDetailsData,
                                }}
                            />
                        </div>
                        {/* } */}

                    </Modal.Body>

                </Modal>
            </>

        )
    }

}

export default withRouter(connect(null, { fill_action, get_additional_services_action, postUpdate_additional_services_action, getServiceVendorPackageDetail_action })(AdditionalServices));
